import {
    putPermiseLoading,
    putPermiseRequest,
    putPermiseSuccess,
    putPermiseReject,
    putPermiseReset
} from "../../actions/profile/putPermise";

export const putPermise = (formData) => async (dispatch, getState) => {
    dispatch(putPermiseLoading());
    try {
        const { data } = await putPermiseRequest(formData, getState);
        dispatch(putPermiseSuccess(data))
    } catch (error) {
        dispatch(putPermiseReject(error))
    } finally {
        setTimeout(() => { dispatch(putPermiseReset()) }, 3000);
    }
    return Promise.resolve();
};